import React, { useEffect, useRef, useState } from 'react'
import * as classes from './Main.module.scss'
import cn from 'classnames'
import Header from '../../ui/Header/Header'
import ThirdScreen from './ThirdScreen/ThirdScreen'
import FourthScreen from './FourthScreen/FourthScreen'
import SixthScreen from './SixthScreen/SixthScreen'
import FirstScreenV2 from './FirstScreenV2/FirstScreenV2'
import { useDataThirdScreenByHy } from './ThirdScreen/useDataThirdScreenByHy'
import { useDataThirdScreenByEn } from './ThirdScreen/useDataThirdScreenByEn'

function Main({ lang }) {
    const thirdScreenRef = useRef(null)
    const [isThirdScreenVisible, setIsThirdScreenVisible] = useState(false)

    const dataThirdScreenByHy = useDataThirdScreenByHy()
    const dataThirdScreenByEn = useDataThirdScreenByEn()

    const dataThirdScreen = lang === 'hy' ? dataThirdScreenByHy : dataThirdScreenByEn
    const aboutImage = dataThirdScreen.heroImage?.image?.url

    useEffect(() => {
        const node = thirdScreenRef.current

        if (!node || typeof IntersectionObserver === 'undefined') {
            return
        }

        const observer = new IntersectionObserver(([entry]) => setIsThirdScreenVisible(entry.isIntersecting), { threshold: 0.5 })

        observer.observe(node)

        return () => observer.disconnect()
    }, [])

    return (
        <section className={classes.Section}>
            <Header light={!isThirdScreenVisible} lang={lang} />

            <div className={classes.Slides}>
                <div className={cn(classes.Slide, 'js-block-dark')} id='intro-slide-1'>
                    <FirstScreenV2 lang={lang} />
                </div>

                <div
                    className={`${classes.Slide} ${classes.AboutSlide}`}
                    id='intro-slide-3'
                    ref={thirdScreenRef}
                    style={{ backgroundImage: `url(${aboutImage})` }}
                >
                    <ThirdScreen lang={lang} />
                </div>

                <div className={classes.NumbersSlide} id='intro-slide-4'>
                    <FourthScreen lang={lang} />
                </div>

                <div className={cn(classes.Slide, classes.ProjectsSlide, 'js-block-dark')} id='intro-slide-6'>
                    <SixthScreen lang={lang} />
                </div>
            </div>
        </section>
    )
}

export default Main
